/**
 * All strings used to represent ranks in their default sort order.
 */
export const ranks = [
  "",
  "6 mon", // vit-gult
  "5 mon", // gul-vitt
  "5 kyu", // gult
  "4 mon", // vit-orange
  "3 mon", // orange-vitt
  "4 kyu", // orange
  "2 mon", // vit-grönt
  "1 mon", // grön-vitt
  "3 kyu", // grönt
  "2 kyu", // blått
  "1 kyu", // brunt
  "1 dan",
  "2 dan",
  "3 dan",
  "4 dan",
  "5 dan",
  "6 dan",
  "7 dan",
  "8 dan",
  "9 dan",
  "10 dan"
];

/**
 * The old mon ranks (before 2024) are represented with a dash '-' instead of a space.
 */
export const oldRanks = [
  "5-mon", // gul-vitt
  "4-mon", // orange-vitt
  "3-mon", // grön-vitt
  "2-mon", // blå-vitt
  "1-mon"  // brun-vitt
];

const rankDescriptions = [
  "vit",
  "vit-gult",
  "gul-vitt",
  "gult",
  "vit-orange",
  "orange-vitt",
  "orange",
  "vit-grönt",
  "grön-vitt",
  "grönt",
  "blått",
  "brunt",
  "1 dan",
  "2 dan",
  "3 dan",
  "4 dan",
  "5 dan",
  "6 dan",
  "7 dan",
  "8 dan",
  "9 dan",
  "10 dan"
];

const oldRankDescriptions = [
  "gul-vitt (före 2024)",
  "orange-vitt (före 2024)",
  "grön-vitt (före 2024)",
  "blå-vitt (före 2024)",
  "brun-vitt (före 2024)"
];

export const rankOptions = ranks.map((name, index) => { return { value: name, text: rankDescriptions[index] }})
export const oldRankOptions = oldRanks.map((name, index) => { return { value: name, text: oldRankDescriptions[index] }})

/**
 * Returns true if testedRank is greater than targetRank
 */
export function rankGreaterThan(testedRank, targetRank) {
  // Having no rank is never greater
  if (testedRank === '') {
    return false
  }

  // Any rank is greater than no rank
  if (targetRank === '') {
    return true
  }

  const targetNewRankIndex = ranks.indexOf(targetRank)
  if (targetNewRankIndex >= 0) {
    const testedNewRankIndex = ranks.indexOf(testedRank)
    return testedNewRankIndex > -1 && testedNewRankIndex > targetNewRankIndex
  }

  const testedOldRankIndex = oldRanks.indexOf(testedRank)
  if (testedOldRankIndex >= 0) {
    const targetOldRankIndex = oldRanks.indexOf(targetRank)
    return testedOldRankIndex > targetOldRankIndex
  }
  return true
}

export function sortRanks(a, b) {
  if (rankGreaterThan(a, b)) return 1
  if (rankGreaterThan(b, a)) return -1
  return 0
}
